import React from 'react';

import { Container, Row, Col, Heading, Text } from 'aplazame-design-system';
import { default as ButtonComponent } from 'aplazame-design-system/src/components/GatsbyTransitionButtonComponent';

import CardEventComponent from '../CardEventComponent';

import style from './style.module.scss';
import textStyle from 'aplazame-design-system/src/scss/text.module.scss';


export default function EventsHomeSection({
    title,
    subtitle,
    events,
    button,
    previousSectionType
}) {
    return (
        <section>
            {previousSectionType === 'DatoCmsWebinarsHomeSection' ? (
                <Container>
                    <div
                        data-sal="slide-up"
                        data-sal-easing="ease-out-quart"
                        className={style.separator}
                    />
                </Container>
            ) : null}
            <Container 
                pt={{ xs: 11, lg: 15 }}
                pb={{ xs: 7, lg: 20 }}
            >
                <Row>
                    <Col
                        pb={{ xs: 3 }}
                        col={{ lg: 4 }}
                    >
                        <Heading
                            tag="h3"
                            mb={{ xs: 3, lg: 4 }}
                            mt={{ lg: 5 }}
                            className={`h2 font-weight-bold ${textStyle.gradual}`}
                            data-sal="slide-up"
                            data-sal-easing="ease-out-quart"
                        >
                            {title}
                        </Heading>
                        <Text
                            tag="div"
                            className="h4"
                            mb={{ xs: 2, lg: 6 }}
                            data-sal="slide-up"
                            data-sal-easing="ease-out-quart"
                        >
                            {subtitle}
                        </Text>
                        {button ? (
                            <div
                                data-sal="slide-up"
                                data-sal-easing="ease-out-quart"
                            >
                                <ButtonComponent
                                    buttonClassName={button.detached ? '' : style.button}
                                    button={button}
                                />
                            </div>
                        ) : null}
                    </Col>
                    {events && events.length ? (
                        events.map((event, i) => (
                            <Col
                                key={i}
                                col={{ lg: 4 }}
                                pb={{ xs: 7 }}
                                data-sal="slide-up"
                                data-sal-easing="ease-out-quart"
                                data-sal-delay={`xs-none--lg-${(i + 1) * 100}`}
                            >
                                <CardEventComponent
                                    {...event}
                                />
                            </Col>
                        ))
                    ) : null}
                </Row>
            </Container>
        </section>
    );
}